import React, { PropsWithChildren } from 'react';
import Container from '@mui/material/Container';
import { getHelpCenterUrl } from '@yi/core/src/help-center-urls';
import { i18n_all_content } from '@yi/i18n/phrases/i18n_all_content';
import { i18n_all_rights_reserved } from '@yi/i18n/phrases/i18n_all_rights_reserved';
import { i18n_copyright } from '@yi/i18n/phrases/i18n_copyright';
import { i18n_need_help } from '@yi/i18n/phrases/i18n_need_help';
import { i18n_privacy_policy } from '@yi/i18n/phrases/i18n_privacy_policy';
import { i18n_terms_of_service } from '@yi/i18n/phrases/i18n_terms_of_service';

import { CopyRight, FooterContainer } from './elements';
import { useLocale } from '../../LocaleProvider';

export const SimpleFooter: React.FC<PropsWithChildren> = () => {
  const { locale } = useLocale();

  return (
    <FooterContainer>
      <Container maxWidth="xl">
        <CopyRight>
          <a href={getHelpCenterUrl('home', locale)}> {i18n_need_help(locale)}</a>{' '}
          <a href="https://try.yogainternational.com/brochure-privacy-policy/">
            {i18n_privacy_policy(locale)}
          </a>
          . <a href="/terms-of-service/">{i18n_terms_of_service(locale)}</a>
        </CopyRight>
        <CopyRight>
          {i18n_all_content(locale)} &copy; {i18n_copyright(locale)}
          {/* {current_time format="%Y'}.  */}
          {i18n_all_rights_reserved(locale)}.
        </CopyRight>
      </Container>
    </FooterContainer>
  );
};
